<mat-select style="min-width: 180px;" [placeholder]="title" class="facet-title">
    <mat-option *ngFor="let facetVal of sortedFacetValues" (click)="selectFacetValue($event, facetVal)">
        {{ facetVal.title }} {{facetData?.getValue(facetVal?.facetKey) | formattedNumber}}
    </mat-option>
</mat-select>